export const emptyGuid = "00000000-0000-0000-0000-000000000000";

export const GeneralAndFeatures = 'General & Features';
export const RevisedCodes_ScorecardElements = 'Revised Codes - Scorecard Elements';
export const SectorSpecificScorecardElements = 'Sector Specific Scorecard Elements';
export const EmploymentEquity = 'Employment Equity';
export const EE123DisplayName = "EE123";
export const Platform = "Platform";
export const EmployeeHubRoles = "Employee Hub Roles";
export const SiteAdminRoles = "Site Admin";

export const MAX_INTEGER = 2147483647;